module.exports = __webpack_public_path__ + "media/images/patterns/header-profile-skin-2-69232608c1083c1d5b5d17b573d58748.png";